// src/elements/Table/Table.Tr.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Tr = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */jsx("tr", {
    className: clsx("pd:table__tr", className),
    children
  });
};
var Table_Tr_default = Tr;
export { Table_Tr_default };